import React, { useEffect, useRef } from "react";
import { connect } from "react-redux";
import { FaqsQuestionAndAnswer } from "../../../react-components/page-framework/support-nav/faqs-question-answer";
import { FaqPageJsonLd } from "../../../react-components/seo/faq-page-json-ld";
import { OrganizationJsonLd } from "../../../react-components/seo/organization-json-ld";
import Mailchimp from "react-mailchimp-form";
import { AppState, store } from "../../../redux";
import { setAuthState } from "../../../redux/actions";
import { AUTHENTICATION_MODAL_ID, AUTH_SIGNUP } from "../../../redux/authentication/constants";
import { HOMEPAGE_FAQ_ITEMS, HomepageFaqItem } from "../../../constants/homepage-faq";

function renderFaqAnswer(item: HomepageFaqItem): React.ReactNode {
  if (item.link) {
    return (
      <p className="answer">
        {item.paragraphs.map((paragraph, index) => (
          <React.Fragment key={index}>
            {paragraph}
            {index < item.paragraphs.length - 1 ? (
              <>
                <br />
                <br />
              </>
            ) : null}
          </React.Fragment>
        ))}
        <br />
        <br />
        {item.link.afterText}
        <a
          href={item.link.href}
          onClick={(event: React.MouseEvent<HTMLElement>) => {
            event.preventDefault();
            window.open(item.link.href, "_blank");
          }}
        >
          {item.link.label}
        </a>
      </p>
    );
  }

  return (
    <p className="answer">
      {item.paragraphs.map((paragraph, index) => (
        <React.Fragment key={index}>
          {paragraph}
          {index < item.paragraphs.length - 1 ? (
            <>
              <br />
              <br />
            </>
          ) : null}
        </React.Fragment>
      ))}
    </p>
  );
}

const faq = () => {
  const myRef = useRef(null);

  useEffect(() => {
    const currentUrl = window.location.href;
    const scrollTofaq = currentUrl.includes("#:faq");
    if (scrollTofaq) {
      window.scrollTo({ behavior: "smooth", top: myRef.current.offsetTop });
    }
  }, []);

  return (
    <section ref={myRef} className="faq-container" id="faq">
      <FaqPageJsonLd />
      <OrganizationJsonLd />
      <div className="getting-started-header">
        <div className="gs-btn">
          <button
            data-toggle="modal"
            data-backdrop="static"
            data-keyboard="false"
            data-target={`#${AUTHENTICATION_MODAL_ID}`}
            onClick={() => {
              store.dispatch(setAuthState({ step: AUTH_SIGNUP }));
            }}
          >
            Join
          </button>
        </div>
      </div>

      <div className="signup">
        <p className="mission-description">Receive Radivision’s updates and newsletter directly in your inbox.</p>
        <div id="gettingStartedPanel">
          <Mailchimp
            action="https://radivision.us14.list-manage.com/subscribe/post?u=c735e455810145c521bf76b4d&amp;id=f9c2e477d1"
            fields={[
              {
                name: "EMAIL",
                placeholder: "Email address ...",
                type: "email",
                required: true,
              },
            ]}
            messages={{
              sending: "Sending...",
              success: "Thank you for subscribing!",
              error: "An unexpected internal error has occurred.",
              empty: "You must write an e-mail.",
              duplicate: "Too many subscribe attempts for this email address",
              button: "Subscribe",
            }}
            className="d-inline-flex flex-sm-row flex-column"
          />
        </div>
      </div>

      <h1 className="heading">Frequently Asked Questions</h1>

      <div className="question-and-answer">
        {HOMEPAGE_FAQ_ITEMS.map((item) => (
          <FaqsQuestionAndAnswer key={item.question} question={item.question} answer={renderFaqAnswer(item)} />
        ))}
      </div>
    </section>
  );
};

const mapState = (state: AppState) => ({
  user: state.account.user,
});

const mapDispatch = {};

export const FAQ = connect(mapState, mapDispatch)(faq);
